// Utility service
// ( used to store all unrelated helper functions we need )

const UtilsService = {

  // Remove locale from url
  // for following url /se/blog/ will return /blog/
  // ( Works only for pages with locale for now as example )
  removeLocaleFromUrl: () => {
    return (typeof window !== 'undefined') ? window.location.pathname.slice(3) : null;
  },

  helloRetailSortCategories: (categories, country) => {
    const sortedCategories = categorySortList[country] || categorySortList.default;
    const sortedCategoriesArray = [];
    categories.forEach((category) => {
      const index = sortedCategories.indexOf(category.title.replace('$', ''));
      if (index !== -1) {
        sortedCategoriesArray[index] = category;
      }
    });
    return sortedCategoriesArray;
  },

  getHelloRetailKey: (type, lang) => {

    const helloRetailKeys = {
      se: {
        shop: '6731ee53f70f28079617be13',
        search: 'fe63a994-088e-4fbb-8594-7481b4279b11'
      },
      dk: {
        shop: '673f446dc9001567a60aa53c',
        search: 'adad9a50-853c-44fc-8c43-b7a786a05dea'
      },
      eu: {
        shop: '673f441c3eb22832f14cefc7',
        search: 'ac525cec-08d6-406a-85ec-d09ca3fb0613'
      },
      no: {
        shop: '673f43daad18ef5a36543166',
        search: '14c427a7-cb4f-4e02-9aff-bc9ab64ce992'
      },
      nl: {
        shop: '673f44b4e66f4710a1791ea0',
        search: '70391837-1c8c-4ecb-840d-ae4b2cba2fa3'
      },
      fr: {
        shop: '673f449bad18ef5a36545b9c',
        search: '55c6083a-ee2d-4ca5-b860-210b4602b802'
      },
      uk: {
        shop: '673f441c3eb22832f14cefc7',
        search: 'ac525cec-08d6-406a-85ec-d09ca3fb0613'
      }
    }
    if (type === 'shop') {

      return helloRetailKeys[lang].shop;

    } else {

      return helloRetailKeys[lang].search;
    }


  },

  // Extract current locale from URL
  getLocaleFromUrl: () => {
    if (typeof window !== 'undefined') {

      const localeMap = {
        se: 'sv-SE',
        dk: 'da',
        eu: 'en',
        no: 'no',
        nl: 'nl',
        fr: 'en',
        uk: 'en-GB'
      }
      const country = window.location.pathname.split("/")[1] !== "" ? window.location.pathname.split("/")[1] : 'eu';
      const lang = localeMap[country] !== 'undefined' ? localeMap[country] : 'en';
      return { country: country, lang: lang };
    } else {
      return { country: 'eu', lang: 'en' }
    }
  },

  localeMap: {
    se: 'sv-SE',
    dk: 'da',
    eu: 'en',
    no: 'no',
    nl: 'nl',
    fr: 'en',
    uk: 'en-GB'
  },

  evaluate: (subtree, context = window) => {
    function getSnippetType(script) {
      return script.type || '';
    }
    function getRawSnippet(script) {
      return script.text || script.textContent || script.innerHTML || '';
    }

    if (subtree) {
      try {
        const scripts = subtree.getElementsByTagName('script');
        const scriptsAsArray = Array.from(scripts).filter(script => getSnippetType(script) !== 'application/json');

        scriptsAsArray.forEach((script) => {
          const unescaped = getRawSnippet(script).replace(/\\/gi, '');
          eval.call(context, unescaped);
        });
      } catch (error) {
        // tslint:disable-next-line:no-console
        console.error('Catched error in evaluate function:', error);
      }
    }
  }
};


const categorySortList = {
  se: ["Massagepistoler",
    "Massagekuddar",
    "Massagedyna",
    "Fotmassage",
    "Kompression",
    "Värmeterapi",
    "Reuse",
    "Isbad",
    "Rödljusterapi",
    "TENS",
    "Rollers",
    "Träning",
    "Yoga",
    "Tillbehör"],
  dk: ['Massagepistoler', 'Massagepuder', 'Massagesæde', 'Fodmassage', 'Kompression', 'Varmeterapi', 'Reuse', 'Isbad', 'Rødtlysterapi', 'TENS', 'Rollers', 'Træning', 'Yoga', 'Tilbehør'],
  default: ['Massage Guns', 'Massage Cushions', 'Massage Seat Cushion', 'Foot Massage', 'Compression', 'Heat Therapy', 'Reuse', 'Cold Plunge', 'Red Light Therapy', 'TENS', 'Rollers', 'Training', 'Yoga', 'Accessories']
}

export default UtilsService;
